import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { palette, useIsMobile, Stack } from '@hub-la/design-system';
import { styled, Skeleton as Skeleton$1 } from '@mui/material';
import { times } from 'lodash';

let _ = t => t,
  _t;
const Skeleton = styled(Skeleton$1)(_t || (_t = _`
  border-radius: 4px;
  background-color: ${0};
`), palette('onSurfaceVariant'));
const LoadingState = () => {
  const isMobile = useIsMobile();
  return isMobile ? jsxs(Stack, Object.assign({
    direction: "column",
    spacing: 5
  }, {
    children: [jsx(Stack, Object.assign({
      direction: "row",
      spacing: 4
    }, {
      children: times(2, idx => jsx(Skeleton, {
        variant: "rectangular",
        animation: "wave",
        width: "100%",
        height: 49
      }, idx))
    })), jsx(Skeleton, {
      variant: "rectangular",
      animation: "wave",
      width: "100%",
      height: 49
    })]
  })) : jsxs(Stack, Object.assign({
    direction: "column",
    spacing: 6,
    p: 6
  }, {
    children: [jsx(Stack, Object.assign({
      direction: "row",
      spacing: 4,
      pt: 6
    }, {
      children: times(2, idx => jsx(Skeleton, {
        variant: "rectangular",
        animation: "wave",
        width: "100%",
        height: 49
      }, idx))
    })), jsx(Skeleton, {
      variant: "rectangular",
      animation: "wave",
      width: "100%",
      height: 49
    }), jsxs(Stack, Object.assign({
      direction: "row"
    }, {
      children: [jsx(Stack, Object.assign({
        flex: 1
      }, {
        children: jsx(Skeleton, {
          variant: "rectangular",
          animation: "wave",
          width: 156,
          height: 27
        })
      })), jsx(Skeleton, {
        variant: "rectangular",
        animation: "wave",
        width: 123,
        height: 27
      })]
    })), times(3, idx => jsx(Skeleton, {
      variant: "rectangular",
      animation: "wave",
      width: "100%",
      height: 100
    }, idx)), times(3, idx => jsxs(Stack, Object.assign({
      direction: "row"
    }, {
      children: [jsx(Stack, Object.assign({
        flex: 1
      }, {
        children: jsx(Skeleton, {
          variant: "rectangular",
          animation: "wave",
          width: 156,
          height: 27
        })
      })), jsx(Skeleton, {
        variant: "rectangular",
        animation: "wave",
        width: 123,
        height: 27
      })]
    }), idx))]
  }));
};

export { LoadingState };
